import { goBack } from "assets/icons";
import styled from "@emotion/styled";
import { Card, Col, Form, Row, Typography, message } from "antd";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import { FC, useEffect, useState } from "react";
import MainCreateTransportation from "../CreateTransportation/MainCreateTransportation";
import { useGetTransportationTypeByFactory } from "hooks/useFactory";
import UpdateTransportationFooter from "./UpdateTransportationFooter";
import {
  useGetMasterTransportById,
  useUpdateMasterTransport,
} from "hooks/useMasterData";
import dayjs from "dayjs";
import { useAppSelector } from "store";
import { ParkinglistInput, ParkingLists } from "services/interface";
import { useQueryClient } from "@tanstack/react-query";

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 12 },
  },
};
interface UpdateTransportationProps {
  id: string;
}
const UpdateTransportation: FC<UpdateTransportationProps> = ({ id }) => {
  const factoryId = useAppSelector(
    (state) => state.auth.profile?.user?.role?.ref_id
  );
  const navigate = useNavigate();
  const { data: dataTransportation } = useGetTransportationTypeByFactory(
    factoryId ?? ""
  );
  const { data: transportData, refetch } = useGetMasterTransportById(id);
  const { mutate: UpdateTransportation, isPending: updateLoading } =
    useUpdateMasterTransport();
  const [form] = Form.useForm();
  const [parkingListInput, setParkingListInput] = useState<ParkinglistInput[]>(
    []
  );

  const queryClient = useQueryClient();

  useEffect(() => {
    const dataTransport = transportData?.data;
    form.setFieldsValue({
      transport_name: dataTransport?.transport.name,
      province_start_id: dataTransport?.transport.province_start_id,
      district_start_id: dataTransport?.transport.district_start_id,
      province_end_id: dataTransport?.transport.province_end_id,
      district_end_id: dataTransport?.transport.district_end_id,
      timeEnd: dayjs(dataTransport?.transport.time_end, "HH:mm"),
      timeStart: dayjs(dataTransport?.transport.time_start, "HH:mm"),
      type: dataTransport?.transport.type,
      license_plate: dataTransport?.transport.license_plate,
      car_no: dataTransport?.transport.car_no,
      // service_price: dataTransport?.service_price,
      // description: dataTransport?.description,
      station_end: dataTransport?.transport.station_end,
      station_start: dataTransport?.transport.station_start,
    });
  }, [transportData]);

  const onFinish = (values: any) => {
    UpdateTransportation(
      {
        id: id,
        name: values.transport_name,
        province_start_id: values.province_start_id,
        district_start_id: values.district_start_id,
        province_end_id: values.province_end_id,
        district_end_id: values.district_end_id,
        time_end: dayjs(values?.timeEnd).format("HH:mm") || "",
        time_start: dayjs(values?.timeStart).format("HH:mm") || "",
        type: values.type,
        license_plate: values.license_plate,
        car_no: values.car_no,
        // service_price: values.service_price,
        description: values.description,
        station_end: values.station_end,
        station_start: values.station_start,
        parking_list: parkingListInput,
      },
      {
        onSuccess: async () => {
          await queryClient.refetchQueries({
            queryKey: ["parkingTransportProvinceType"],
            type: "all",
          });
          message.success("แก้ไขข้อมูลขนส่งสำเร็จ");
          refetch();
          // navigate("/manage-transportation")
        },
        onError: (error) => {
          message.error("แก้ไขข้อมูลขนส่งไม่สำเร็จ");
          console.log(error);
        },
      }
    );
  };

  return (
    <Form form={form} {...formItemLayout} onFinish={onFinish}>
      <Row className="rowgap-vbox" gutter={[24, 0]}>
        <Col span={24}>
          <Card bordered={false} className="criclebox h-full tabs-mobile">
            <HeaderTabs>
              <IconWrapper
                onClick={() => {
                  navigate("/manage-transportation");
                }}
              >
                <SpanIcon>{goBack}</SpanIcon>
              </IconWrapper>
              <Typography.Title level={5}>แก้ไขขนส่ง</Typography.Title>
              <RightIconWrapper></RightIconWrapper>
            </HeaderTabs>
            <WrapperAll>
              <MainCreateTransportation
                data={transportData?.data}
                dataType={dataTransportation?.data}
                form={form}
                parkingListInput={parkingListInput}
                setParkingListInput={setParkingListInput}
              />
            </WrapperAll>
          </Card>
        </Col>
      </Row>
      <UpdateTransportationFooter />
    </Form>
  );
};

export default UpdateTransportation;

const HeaderTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-direction: row;
  border-bottom: 1px solid #efefef;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 30px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const RightIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const WrapperAll = styled.div`
  display: block;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;
